import { onLoad } from "@otto-ec/global-resources/dom";
import { flushQueue, isSafari } from "./metrics";

export const visibilitychangeHandler = () => {
  if (document.visibilityState === "hidden") {
    flushQueue();
  }
};

/**
 *
 *
 *
 *
 *
 */
export const initFlushQueue = (safari = isSafari()): void => {
  /*                                                                             */
  if (safari) {
    /*                                                              */
    onLoad.subscribe(flushQueue);

    /*                                                             */
    window.addEventListener("pagehide", flushQueue);
  }

  /*             */
  /*                                                                     */
  window.addEventListener("visibilitychange", visibilitychangeHandler);
};
